import React from 'react';
import AdWrapper from '../../components/AdWrapper';
import PropTypes from 'prop-types';
import { AD_PAGES } from '../../../utils/adsUtils';
import { isMobile } from '../../../utils/commonUtils';
import '../../../styles/RailsLandingSeo.css';

const RailsLandingPageAds = (props) => {
  function getAd(pageName) {
    return isMobile() && <AdWrapper adsPageName={pageName} />;
  }

  const MultibannerAd = () => <div className="multibannerAds">{getAd(AD_PAGES.RAILS_LANDING_AD.adsPageName)}</div>;
  const ExclusivePartner = () => (
    <div className="exclusivePartnerAd">
      <span>{props.exclusivePartnersText}</span>
      {getAd(AD_PAGES.RAILS_LANDING_EXCLUSIVE_PARTNERS.adsPageName)}
    </div>
  );
  const SnackbarAd = () => <div className="snackBarAd">{getAd(AD_PAGES.RAILS_LANDING_SNACKBAR.adsPageName)}</div>;

  return (
    <div className="railsLandingAds">
      <MultibannerAd />
      <ExclusivePartner />
      <SnackbarAd />
    </div>
  );
};

RailsLandingPageAds.propTypes = {
  exclusivePartnersText: PropTypes.string.isRequired
};
export default RailsLandingPageAds;
